import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IAutoSourceClipsFromSubtitlesV1Request } from './auto-source-clips-from-subtitles-v1-request';
import type { IAutoSourceClipsFromSubtitlesV1Response } from './auto-source-clips-from-subtitles-v1-response';
import { autoSourceClipsFromSubtitlesV1ResponseSchema } from './auto-source-clips-from-subtitles-v1-response';

export async function autoSourceClipsFromSubtitlesV1Api({
  challengeId,
}: IAutoSourceClipsFromSubtitlesV1Request): Promise<
  IValidatedResponse<IAutoSourceClipsFromSubtitlesV1Response>
> {
  return postRequest<IAutoSourceClipsFromSubtitlesV1Response>({
    path: `/sys/challenges/v1/${challengeId}/clips/auto-source`,
    schema: autoSourceClipsFromSubtitlesV1ResponseSchema,
  });
}
